import { Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideInfo } from '@ng-icons/lucide';
import { TranslatePipe } from '@ngx-translate/core';
import { ClassValue } from 'clsx';

import { KnxAlert, KnxAlertDescription } from '@optical/ui/alert';

@Component({
  selector: 'knx-password-policy',
  providers: [provideIcons({ lucideInfo })],
  imports: [KnxAlert, KnxAlertDescription, NgIcon, TranslatePipe],
  templateUrl: './password-policy.component.html',
})
export class PasswordPolicyComponent {
  readonly userClass = input<ClassValue>('', { alias: 'class' });
}
